<template>
  <v-card
    class="overviewCard"
    color="primary"
    dark
    :style="{
      'background-image':
        'url(' + bucketUrl + '/assets/background_dashboard.png)'
    }"
  >
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="12" md="12">
          <h2 class="name">Hi {{ name }}</h2>
        </v-col>
        <v-col
          v-for="i in emptyFigures"
          :key="`emptyFigures-${i}`"
          cols="6"
          md="4"
          class="analytics"
        />
        <v-col
          v-if="
            registeredTeachers !== null &&
              allowedFigures.includes('registeredTeachers')
          "
          cols="6"
          md="4"
          class="analytics"
        >
          <span class="figure">{{ registeredTeachers }}</span>
          <p class="label">
            {{
              registeredTeachers && registeredTeachers === 1
                ? 'Registered User'
                : 'Registered Users'
            }}
          </p>
        </v-col>
        <v-col
          v-if="
            availableWorkshops !== null &&
              allowedFigures.includes('availableWorkshops')
          "
          cols="6"
          md="4"
          class="analytics"
        >
          <span class="figure">{{ availableWorkshops }}</span>
          <p class="label">
            {{ `Available ${this.capitalizeFirstLetter(this.lessonTerm)}s` }}
          </p>
        </v-col>
        <v-col
          v-if="
            activeStudents !== null && allowedFigures.includes('activeStudents')
          "
          cols="6"
          md="4"
          class="analytics"
        >
          <span class="figure">{{ activeStudents }}</span>
          <p class="label">{{ activeStudents > 1 ? 'Students' : 'Student' }}</p>
        </v-col>
        <v-col
          v-if="
            activeClasses !== null && allowedFigures.includes('activeClasses')
          "
          cols="6"
          md="4"
          class="analytics"
        >
          <span class="figure">{{ activeClasses }}</span>
          <p class="label">
            {{ activeClasses > 1 ? 'Classes' : 'Class' }}
          </p>
        </v-col>
        <v-col
          v-if="
            completedLessons !== null &&
              allowedFigures.includes('completedLessons')
          "
          cols="6"
          md="4"
          class="analytics"
        >
          <span class="figure">{{ completedLessons }}</span>
          <p class="label">
            {{ `Completed ${this.capitalizeFirstLetter(this.lessonTerm)}s` }}
          </p>
        </v-col>
        <!-- <v-col
          v-if="
            badgesAwarded !== null && allowedFigures.includes('badgesAwarded')
          "
          cols="4"
          md="2"
          class="analytics"
        >
          <span class="figure">{{ badgesAwarded }}</span>
          <p class="label">
            Badges Awarded
          </p>
        </v-col> -->
        <v-col
          v-if="
            activeChildren !== null && allowedFigures.includes('activeChildren')
          "
          cols="6"
          md="4"
          class="analytics"
        >
          <span class="figure">{{ activeChildren }}</span>
          <p class="label">
            {{ activeChildren && activeChildren === 1 ? 'Child' : 'Children' }}
          </p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Auth from '@/modules/auth/models/Auth'
import { mapState } from 'vuex'
import Vue from 'vue'

export default {
  name: 'OverviewCard',
  props: {
    completedLessons: {
      type: Number,
      default: null
    },
    badgesAwarded: {
      type: Number,
      default: null
    },
    availableWorkshops: {
      type: Number,
      default: null
    },
    activeStudents: {
      type: Number,
      default: null
    },
    activeChildren: {
      type: Number,
      default: null
    },
    activeClasses: {
      type: Number,
      default: null
    },
    registeredTeachers: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      allowedFigures: [],
      emptyFigures: 0,
      numberOfFigures: 3
    }
  },
  computed: {
    me() {
      let type = this.$route.meta.type
      if (type == 'user') type = 'student'
      return Auth.query()
        .where('type', type)
        .first()
    },
    ...mapState(['bucketUrl', 'lessonTerm']),
    name() {
      let name = ''
      if (this.me.first_name && this.me.last_name) {
        name =
          Vue.filter('capitalize')(this.me.first_name) +
          ' ' +
          Vue.filter('capitalize')(this.me.last_name)
      } else if (this.me.first_name) {
        name = Vue.filter('capitalize')(this.me.first_name)
      } else if (this.$route.meta.type === 'client') {
        name = this.me.name
      } else if (this.$route.meta.type === 'user') {
        name =
          this.me.profile[0].first_name + ' ' + this.me.profile[0].last_name
      } else {
        name = this.me.email
      }

      return name
    }
  },
  watch: {
    $props: {
      handler() {
        this.calculateAllowedFigures()
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    this.calculateAllowedFigures()
  },
  methods: {
    calculateAllowedFigures() {
      let index = 0
      for (const key in this.$props) {
        const value = this.$props[key]
        if (value !== null && value >= 0) {
          if (index < this.numberOfFigures) {
            this.allowedFigures.push(key)
          }
          index++
        }
      }
      this.emptyFigures = this.numberOfFigures - index
    }
  }
}
</script>

<style lang="scss">
.overviewCard {
  display: block;
  width: 100%;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;

  h2 {
    font-size: 55px;
    line-height: 55px;
    padding: 0;
    margin: 0;
    font-weight: normal;
    color: white;
  }

  h3 {
    font-size: 30px;
    font-weight: normal;
    color: white;
  }

  .analytics {
    text-align: center;

    .figure {
      font-size: 90px;
      padding: 0;
      max-width: 0;
      line-height: 140px;
      color: white;

      &.students {
        font-size: 100px;
      }
    }
    .label {
      padding: 0;
      font-size: 18px;
      color: white;
    }
  }
}
</style>
